import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Grid from '@mui/material/Grid';
import { Auth } from 'aws-amplify';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import FormInputText from '../../common/Forms/FormTextField';
import InputDropdown from '../../common/Forms/InputDropdown';
import FormInputMultiCheckbox from '../../common/Forms/FormCheckbox';
import {
  EPISODE_PROFB1_UPDATE_URL,
  EPISODE_PROFB1_URL,
  EPISODE_PROFB2_URL,
  formDateFormat,
  yesNoDropdown,
  maxLength
} from '../../../constants';
import {
  setIsProfB1DataLoaded,
  setCountyOfLastLegalResidenceId,
  setDateReceivedCDC,
  setLengthOfTermInYrsAndMos,
  setLengthOfTermInYrs,
  setLengthOfTermInMos,
  setSecondStrike,
  setCommitmentOffenses,
  // setExpectedPrisonReleaseDate,
  // setControllingDischargeDate,
  setComments,
  setReleaseDate,
  setControllingDchDate,
  setEPRD,
  setRRD,
  setPED,
  setCDD,
  setCDD_MAX,
  setHighControlSupervision,
  setH11590NarcoticRegistration,
  setPC296ViolentOrSeriousOffenderNotification,
  setCity,
  setParoleRegion,
  setHistoryOfConvictions,
  setRSuffixInCentralFile,
  setRSuffixExplination,
  setP290SexRegistration,
  setP457_1ArsonRegistration,
  getProfB1Form,
} from '../../../redux/episode/profB1Tab/profB1FormSlice';
import Typography from '@mui/material/Typography';
import { setStopApi } from '../../../services/StopApi/StopApi';
import FormSuccess from '../../common/Forms/FormSuccess';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import CancelPopUp from '../../common/CancelPopUp/CancelPopUp';
import { setRefreshEpisodeParticipant } from '../../../redux/episode/episodeParticipant/episodeParticipantSlice';
import {
  getSaveCancel,
  useLoading,
} from '../../common/commonUtils/commonUtils';
import ProfB1PdfForm from './ProfB1PDF/ProfB1PdfForm';
import { getProfB2Form } from '../../../redux/episode/profB2Tab/profB2FormSlice';
import { PrintViewGrid } from './ProfA1PdfFormCommonUtils';

const schema = yup.object().shape({
  comments: yup.string().nullable().max(800, `${maxLength} 800`),
  commitmentOffenses: yup.string().nullable().max(800, `${maxLength} 800`),
  historyOfConvictions: yup.string().nullable().max(800, `${maxLength} 800`),
});

const ProfB1 = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [openProfileB1PDF, setOpenProfileB1PDF] = useState(false);
  const { loading, hideLoading } = useLoading();

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );
  const participantID = useSelector(
    (state) => state?.participants?.participantsDetail[0]?.id
  );
  const profB1Form = useSelector((state) => state?.profB1Form);
  const profB1RefernceData = useSelector((state) => state?.profB1RefernceData);

  //console.log(profB1Form)
  const defaultValue = {
    dateReceivedCDC: moment(profB1Form?.dateReceivedCDC).format(formDateFormat),
    lengthOfTermInYrsAndMos: profB1Form?.lengthOfTermInYrsAndMos,
    //lengthOfTermInYrs: profB1Form?.lengthOfTermInYrsAndMos?.split('y')[0],
    //lengthOfTermInMos: profB1Form?.lengthOfTermInYrsAndMos
    //  ?.split('s')[1]
    //  ?.split('m')[0],
    lengthOfTermInYrs: profB1Form?.lengthOfTermInYrs,
    lengthOfTermInMos: profB1Form?.lengthOfTermInMos,
    secondStrike:
      profB1Form?.secondStrike === null ? '' : profB1Form?.secondStrike,
    commitmentOffenses: profB1Form?.commitmentOffenses,
    expectedPrisonReleaseDate: moment(
      profB1Form?.expectedPrisonReleaseDate
    ).format(formDateFormat),
    controllingDischargeDate: moment(
      profB1Form?.controllingDischargeDate
    ).format(formDateFormat),
    comments: profB1Form?.comments,
    releaseDate: moment(profB1Form?.releaseDate).format(formDateFormat),
    controllingDchDate: moment(profB1Form?.controllingDchDate).format(
      formDateFormat
    ),
    EPRD: profB1Form?.EPRD,
    RRD: profB1Form?.RRD,
    PED: profB1Form?.PED,
    CDD: profB1Form?.CDD,
    CDD_MAX: profB1Form?.CDD_MAX,
    highControlSupervision:
      profB1Form?.highControlSupervision === null
        ? ''
        : profB1Form?.highControlSupervision,
    h11590NarcoticRegistration:
      profB1Form?.h11590NarcoticRegistration === null
        ? ''
        : profB1Form?.h11590NarcoticRegistration,
    pC296ViolentOrSeriousOffenderNotification:
      profB1Form?.pC296ViolentOrSeriousOffenderNotification === null
        ? ''
        : profB1Form?.pC296ViolentOrSeriousOffenderNotification,
    countyOfLastLegalResidenceId: profB1Form?.countyOfLastLegalResidenceId
      ? profB1Form?.countyOfLastLegalResidenceId
      : '',
    city: profB1Form?.city,
    paroleRegion: profB1Form?.paroleRegion ? profB1Form?.paroleRegion : '',
    historyOfConvictions: profB1Form?.historyOfConvictions,
    rSuffixInCentralFile: profB1Form?.rSuffixInCentralFile,
    rSuffixExplination:
      profB1Form?.rSuffixExplination === null
        ? ''
        : profB1Form?.rSuffixExplination,
    p290SexRegistration:
      profB1Form?.participant?.p290SexRegistration === null
        ? ''
        : profB1Form?.participant?.p290SexRegistration,
    p457_1ArsonRegistration:
      profB1Form?.participant?.p457_1ArsonRegistration === null
        ? ''
        : profB1Form?.participant?.p457_1ArsonRegistration,
  };

  const useFunction = useForm({ defaultValues: defaultValue, resolver: yupResolver(schema) });
  const { handleSubmit, reset, control, formState, setValue, watch, register } = useFunction;
  const { errors } = formState;   

  //const useFunction = useForm({ defaultValues: defaultValue });
  //const { handleSubmit, reset, control, register } = useFunction;

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    defaultValue?.lengthOfTermInYrs,
    defaultValue?.lengthOfTermInMos,
  ]);

  const fetchData = async () => {
    let profB1TabUrl = `${EPISODE_PROFB1_URL}/${episodeId}/ProfB1`;
    let profB2TabUrl = `${EPISODE_PROFB2_URL}/${episodeId}/ProfB2`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    if (profB1Form?.isProfB1DataLoaded === false) {
      dispatch(getProfB1Form({ profB1TabUrl, authorization }));
      dispatch(getProfB2Form({ profB2TabUrl, authorization }));
      setTimeout(() => {
        dispatch(setIsProfB1DataLoaded(true));
        dispatch(setLengthOfTermInYrs(defaultValue?.lengthOfTermInYrs));
        dispatch(setLengthOfTermInMos(defaultValue?.lengthOfTermInMos));
      }, 1000);
    }
    setTimeout(() => {
      hideLoading();
    }, 500);
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.dateReceivedCDC,
    defaultValue.lengthOfTermInYrsAndMos,
    defaultValue.lengthOfTermInYrs,
    defaultValue.lengthOfTermInMos,
    defaultValue.secondStrike,
    defaultValue.commitmentOffenses,
    defaultValue.expectedPrisonReleaseDate,
    defaultValue.controllingDischargeDate,
    defaultValue.comments,
    defaultValue.releaseDate,
    defaultValue.controllingDchDate,
    defaultValue.EPRD,
    defaultValue.RRD,
    defaultValue.PED,
    defaultValue.CDD,
    defaultValue.CDD_MAX,
    defaultValue.highControlSupervision,
    defaultValue.h11590NarcoticRegistration,
    defaultValue.pC296ViolentOrSeriousOffenderNotification,
    defaultValue.countyOfLastLegalResidenceId,
    defaultValue.city,
    defaultValue.paroleRegion,
    defaultValue.historyOfConvictions,
    defaultValue.rSuffixInCentralFile,
    defaultValue.rSuffixExplination,
    defaultValue.p290SexRegistration,
    defaultValue.p457_1ArsonRegistration,
  ]);

  const yrsMosScenario3 =
    profB1Form.lengthOfTermInYrs?.concat('yrs') +
    profB1Form.lengthOfTermInMos?.concat('mos');

  const onSubmit = () => {
    const url = EPISODE_PROFB1_UPDATE_URL;
    // const p290SexRegistration =
    //   profB1Form?.participant?.p290SexRegistration === ''
    //     ? null
    //     : profB1Form?.p290SexRegistration;
    // const p457_1ArsonRegistration =
    //   profB1Form?.participant?.p457_1ArsonRegistration === ''
    //     ? null
    //     : profB1Form?.p457_1ArsonRegistration;
    // console.log(p290SexRegistration);
    // console.log(p457_1ArsonRegistration);
    const payload = {
      episodeID: episodeId,
      dateReceivedCDC: profB1Form?.dateReceivedCDC,
      lengthOfTermInYrsAndMos: yrsMosScenario3,
      secondStrike:
        profB1Form?.secondStrike === '' ? null : profB1Form?.secondStrike,
      commitmentOffenses: profB1Form?.commitmentOffenses,
      expectedPrisonReleaseDate: profB1Form?.expectedPrisonReleaseDate,
      controllingDischargeDate: null,
      comments: profB1Form?.comments,
      releaseDate: profB1Form?.releaseDate,
      controllingDchDate: profB1Form?.controllingDchDate,
      EPRD: profB1Form?.EPRD,
      RRD: profB1Form?.RRD,
      PED: profB1Form?.PED,
      CDD: profB1Form?.CDD,
      CDD_MAX: profB1Form?.CDD_MAX,
      highControlSupervision:
        profB1Form?.highControlSupervision === ''
          ? null
          : profB1Form?.highControlSupervision,
      ICDTPNumberArrestsAsAnAdult: null,
      approxDateYearOfFirstArrrest: null,
      approxDateYearOfLastArrest: null,
      h11590NarcoticRegistration:
        profB1Form?.h11590NarcoticRegistration === ''
          ? null
          : profB1Form?.h11590NarcoticRegistration,
      pC296ViolentOrSeriousOffenderNotification:
        profB1Form?.pC296ViolentOrSeriousOffenderNotification === ''
          ? null
          : profB1Form?.pC296ViolentOrSeriousOffenderNotification,
      countyOfLastLegalResidenceId: profB1Form?.countyOfLastLegalResidenceId
        ? profB1Form?.countyOfLastLegalResidenceId
        : null,
      city: profB1Form?.city,
      paroleRegion: profB1Form?.paroleRegion,
      historyOfConvictions: profB1Form?.historyOfConvictions,
      rSuffixInCentralFile: profB1Form?.rSuffixInCentralFile,
      rSuffixExplination:
        profB1Form?.rSuffixExplination === ''
          ? null
          : profB1Form?.rSuffixExplination,
      participant: {
        participantID: participantID,
        p290SexRegistration: defaultValue?.p290SexRegistration,
        p457_1ArsonRegistration: defaultValue?.p457_1ArsonRegistration,
      },
    };
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        setFormSuccess(true);
        dispatch(setRefreshEpisodeParticipant(true));
        setTimeout(() => {
          dispatch(setRefreshEpisodeParticipant(false));
        }, 1000);
        dispatch(setLengthOfTermInYrsAndMos(yrsMosScenario3));
      }
    }).catch((e) => alert(e));
  };

  const onError = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  const handleOpenB1Pdf = () => {
    setOpenProfileB1PDF(true);
  };

  if (loading) {
    return <ProgressBar />;
  }

  return (
    <>
      <PrintViewGrid handleOpenPdf={handleOpenB1Pdf} />
      <Grid
        container
        spacing={2}
        style={{ justifyContent: 'center', marginTop: '0px' }}
      >
        <Grid item xs={12} sm={3}>
          <FormInputText
            name="dateReceivedCDC"
            type="date"
            control={control}
            shrink={true}
            label="Date Received CDC"
            register={register('dateReceivedCDC', {
              onBlur: (e) => dispatch(setDateReceivedCDC(e.target.value)),
            })}
          />
          {/* <FormInputText
                  name='lengthOfTermInYrsAndMos'
                  control={control}
                  label='Length Of Terms in Years/Months'
                  // placeholder="1yrs1mos"
                  // register={register('lengthOfTermInYrsAndMos', {
                  //   onChange: (e) =>
                  //     dispatch(setLengthOfTermInYrsAndMos(e.target.value)),
                  // })}
                /> */}
          <FormInputText
            name="lengthOfTermInYrs"
            control={control}
            label="Length Of Terms in Years"
            type="number"
            minValue={0}
            maxValue={99}
            register={register('lengthOfTermInYrs', {
              onBlur: (e) => dispatch(setLengthOfTermInYrs(e.target.value)),
            })}
          />
          <FormInputText
            name="lengthOfTermInMos"
            control={control}
            label="Length Of Terms in Months"
            type="number"
            minValue={0}
            maxValue={12}
            register={register('lengthOfTermInMos', {
              onBlur: (e) => dispatch(setLengthOfTermInMos(e.target.value)),
            })}
          />
          <InputDropdown
            name="secondStrike"
            control={control}
            options={yesNoDropdown}
            defaultId={defaultValue?.secondStrike}
            register={register('secondStrike', {
              onBlur: (e) => dispatch(setSecondStrike(e.target.value)),
            })}
            label="2nd Strike?"
          />
          <FormInputText
            name="commitmentOffenses"
            type="text"
            control={control}
            multiline={true}
            rows={3.5}
            label="Commitment Offense(s)"
            register={register('commitmentOffenses', {
              onBlur: (e) => dispatch(setCommitmentOffenses(e.target.value)),
            })}
            errors={!!errors.commitmentOffenses}
            helperText={errors?.commitmentOffenses?.message}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name="releaseDate"
            type="date"
            control={control}
            shrink={true}
            label="Release Date"
            register={register('releaseDate', {
              onBlur: (e) => dispatch(setReleaseDate(e.target.value)),
            })}
          />
          <FormInputText
            name="controllingDchDate"
            type="date"
            control={control}
            shrink={true}
            label="Controlling Dch Date"
            register={register('controllingDchDate', {
              onBlur: (e) => dispatch(setControllingDchDate(e.target.value)),
            })}
          />
          <InputDropdown
            name="highControlSupervision"
            control={control}
            options={yesNoDropdown}
            defaultId={defaultValue?.highControlSupervision}
            register={register('highControlSupervision', {
              onBlur: (e) =>
                dispatch(setHighControlSupervision(e.target.value)),
            })}
            label="High Control Supervision"
          />
          <InputDropdown
            name="h11590NarcoticRegistration"
            control={control}
            options={yesNoDropdown}
            defaultId={defaultValue?.h11590NarcoticRegistration}
            register={register('h11590NarcoticRegistration', {
              onBlur: (e) =>
                dispatch(setH11590NarcoticRegistration(e.target.value)),
            })}
            label="H11590 Narcotic Registration"
          />
          <InputDropdown
            name="p290SexRegistration"
            control={control}
            options={yesNoDropdown}
            defaultId={defaultValue?.p290SexRegistration}
            register={register('p290SexRegistration', {
              onBlur: (e) => dispatch(setP290SexRegistration(e.target.value)),
            })}
            label="P290 Sex Registration"
          />
          <InputDropdown
            name="p457_1ArsonRegistration"
            control={control}
            options={yesNoDropdown}
            defaultId={defaultValue?.p457_1ArsonRegistration}
            register={register('p457_1ArsonRegistration', {
              onBlur: (e) =>
                dispatch(setP457_1ArsonRegistration(e.target.value)),
            })}
            label="P457.1 Arson Registration"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputDropdown
            name="pC296ViolentOrSeriousOffenderNotification"
            control={control}
            options={yesNoDropdown}
            defaultId={defaultValue?.pC296ViolentOrSeriousOffenderNotification}
            register={register('pC296ViolentOrSeriousOffenderNotification', {
              onBlur: (e) =>
                dispatch(
                  setPC296ViolentOrSeriousOffenderNotification(e.target.value)
                ),
            })}
            label="PC 296 Violent/Serious Offender Notification"
          />
          <InputDropdown
            name="countyOfLastLegalResidenceId"
            control={control}
            options={profB1RefernceData?.counties}
            defaultId={defaultValue?.countyOfLastLegalResidenceId}
            register={register('countyOfLastLegalResidenceId', {
              onBlur: (e) =>
                dispatch(setCountyOfLastLegalResidenceId(e.target.value)),
            })}
            label="County of Last Legal Residence (CLLR)"
          />
          <FormInputText
            name="city"
            type="text"
            control={control}
            shrink={true}
            label="City"
            register={register('city', {
              onBlur: (e) => dispatch(setCity(e.target.value)),
            })}
          />
          <InputDropdown
            name="paroleRegion"
            control={control}
            options={profB1RefernceData?.regions}
            defaultId={defaultValue?.paroleRegion}
            valueAsKey={true}
            register={register('paroleRegion', {
              onBlur: (e) => dispatch(setParoleRegion(e.target.value)),
            })}
            label="Parole Region"
          />
          <FormInputText
            name="historyOfConvictions"
            type="text"
            control={control}
            multiline={true}
            rows={3.5}
            label="History of Convictions"
            register={register('historyOfConvictions', {
              onBlur: (e) =>
                dispatch(setHistoryOfConvictions(e.target.value)),
            })}
            errors={!!errors.historyOfConvictions}
            helperText={errors?.historyOfConvictions?.message}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputDropdown
            name="rSuffixInCentralFile"
            control={control}
            options={yesNoDropdown}
            defaultId={defaultValue?.rSuffixInCentralFile}
            valueAsKey={true}
            register={register('rSuffixInCentralFile', {
              onBlur: (e) =>
                dispatch(setRSuffixInCentralFile(e.target.value)),
            })}
            yesNoDropDown={true}
            label='"R" Suffix In Central File'
          />
          <FormInputText
            name="rSuffixExplination"
            type="text"
            control={control}
            label='If "R" Suffix Yes Explain'
            register={register('rSuffixExplination', {
              onBlur: (e) => dispatch(setRSuffixExplination(e.target.value)),
            })}
          />
          <FormInputText
            name="comments"
            type="text"
            control={control}
            multiline={true}
            rows={3.5}
            label="Comments"
            register={register('comments', {
              onBlur: (e) => dispatch(setComments(e.target.value)),
            })}
            errors={!!errors.comments}
            helperText={errors?.comments?.message}

          />
          <Typography variant="h6">Release Type</Typography>
          <FormInputMultiCheckbox
            control={control}
            name="EPRD"
            label="EPRD"
            checked={defaultValue?.EPRD}
            register={register('EPRD', {
              onBlur: (e) => dispatch(setEPRD(e.target.value)),
            })}
          />
          <FormInputMultiCheckbox
            control={control}
            name="RRD"
            label="RRD"
            checked={defaultValue?.RRD}
            register={register('RRD', {
              onBlur: (e) => dispatch(setRRD(e.target.value)),
            })}
          />
          <FormInputMultiCheckbox
            control={control}
            name="PED"
            label="PED"
            checked={defaultValue?.PED}
            register={register('PED', {
              onBlur: (e) => dispatch(setPED(e.target.value)),
            })}
          />
          <FormInputMultiCheckbox
            control={control}
            name="CDD"
            label="CDD"
            checked={defaultValue?.CDD}
            register={register('CDD', {
              onBlur: (e) => dispatch(setCDD(e.target.value)),
            })}
          />
          <FormInputMultiCheckbox
            control={control}
            name="CDD_MAX"
            label="CDD/MAX"
            checked={defaultValue?.CDD_MAX}
            register={register('CDD_MAX', {
              onBlur: (e) => dispatch(setCDD_MAX(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
      {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit, onError))}
      <FormSuccess formSuccess={formSuccess} setFormSuccess={setFormSuccess} />
      <CancelPopUp cancelPopUp={cancelPopUp} setCancelPopUp={setCancelPopUp} />
      <ProfB1PdfForm open={openProfileB1PDF} setOpen={setOpenProfileB1PDF} />
    </>
  );
};

export default ProfB1;
